// hide header on scroll down - updated

document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.header');
    let lastScrollTop = 0;
    const threshold = 100; // Minimum scroll amount before hiding

    if (!header) return;

    // Check if sticky header is enabled in settings (data attribute on header)
    const isStickyEnabled = header.getAttribute('data-enable-sticky-header') === 'true';
    if (!isStickyEnabled) return;

    window.addEventListener('scroll', function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Ensure we don't trigger when scrolling at the very top (bounce effect)
        if (scrollTop < 0) return;

        if (scrollTop > lastScrollTop && scrollTop > threshold) {
            // Scrolling down
            if (!document.body.classList.contains('is-hover-cart-open')) {
                header.classList.add('header--hidden');
            }
        } else {
            // Scrolling up
            header.classList.remove('header--hidden');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    }, { passive: true });
});

window.toggleReadMore = function (btn) {
  const text = btn.closest('.product__description').querySelector('.custom-color-text');
  text.classList.toggle('expanded');
  const isExpanded = text.classList.contains('expanded');
  btn.textContent = isExpanded ? btn.dataset.readLess : btn.dataset.readMore;
};

// Initialize read more buttons - hide if content doesn't overflow
document.addEventListener('DOMContentLoaded', function() {
  const readMoreButtons = document.querySelectorAll('.read-more-btn');
  
  readMoreButtons.forEach(function(btn) {
    const text = btn.closest('.product__description').querySelector('.custom-color-text');
    
    if (text) {
      // Check if content is actually truncated
      const isOverflowing = text.scrollHeight > text.clientHeight;
      
      if (!isOverflowing) {
        btn.style.display = 'none';
      }
    }
  });
});

// Mobile product card hover toggle
document.addEventListener('click', function(e) {
  // 1. Handle toggle button click
  // We check if the click target is the toggle button or inside it
  const toggleBtn = e.target.closest('.js-mobile-hover-toggle');
  
  if (toggleBtn) {
    e.preventDefault();
    e.stopPropagation(); // Stop bubbling
    
    const productItem = toggleBtn.closest('.product-item');
    if (productItem) {
      // Close other open items
      document.querySelectorAll('.product-item.mobile-hover-active').forEach(item => {
        if (item !== productItem) {
          item.classList.remove('mobile-hover-active');
        }
      });
      
      // Toggle current item
      productItem.classList.toggle('mobile-hover-active');
      
      // Toggle scroll lock handled by CSS now
    }
    return; // Exit as we handled the toggle
  }

  // 2. Handle Auto-close when size/option is selected
  // We do this immediately without waiting for bubbling
  if (
      e.target.closest('.product-item__variant-info input') || 
      e.target.closest('.product-item__variant-info button') ||
      e.target.closest('.product-chips-options__item--chip')
  ) {
      setTimeout(() => {
        document.querySelectorAll('.product-item.mobile-hover-active').forEach(item => {
            item.classList.remove('mobile-hover-active');
        });
        // Scroll lock handled by CSS
      }, 300);
      // We don't return here, in case other handlers need this event
  }

  // 3. Handle Close if clicking outside
  // If we are NOT clicking inside the variant info AND NOT clicking the toggle (handled above)
  if (!e.target.closest('.product-item__variant-info')) {
      document.querySelectorAll('.product-item.mobile-hover-active').forEach(item => {
          item.classList.remove('mobile-hover-active');
      });
      // Scroll lock handled by CSS
  }

}, true); // Use Capture phase

const menuButton = document.querySelector('[data-js-menu-button]');

function closeDrawerMenu() {
  const drawer = document.querySelector('.drawer-menu');
  if (!drawer) return;

  drawer.classList.remove(
    'active',
    'visible',
    'animation--drawer-menu-revealed'
  );

  if (menuButton) {
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu modal');
  }

  const body = document.body;

  body.classList.remove(
    'mobile-menu-open',
    'scroll-lock'
  );

  body.removeAttribute('data-fluorescent-overlay-open');
  body.removeAttribute('style');
}

/* Attach listener safely (for Swym lazy load) */
document.addEventListener('click', function (e) {
  const wishlist = e.target.closest('.swym-wishlist');
  if (!wishlist) return;

  // iOS needs a tiny delay
  setTimeout(closeDrawerMenu, 400);
});

/* Extra support for iOS touch */
document.addEventListener('touchend', function (e) {
  const wishlist = e.target.closest('.swym-wishlist');
  if (!wishlist) return;

  setTimeout(closeDrawerMenu, 400);
});

// collection filter

document.addEventListener('DOMContentLoaded', function() {
  var bannerTrigger = document.getElementById('banner-filter-trigger');
  // Target the mobile filter toggle which is the most reliable drawer trigger
  var realTrigger = document.querySelector('[data-mobile-filters-toggle]');
  
  if (bannerTrigger && realTrigger) {
    bannerTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      realTrigger.click();
    });
  }
});

/**
 * Quick Cart Hover Option
 * Opens the quick cart on hover if the setting is enabled in the header section.
 */
// Helper to find the quick-cart section instance
function getQuickCartInstance() {
  const instances = window.Shopify?.theme?.sections?.instances || [];
  return instances.find(instance => instance.type === 'quick-cart');
}

let closeCartTimeout;

function openQuickCart() {
  clearTimeout(closeCartTimeout);
  
  // Calculate dynamic header offset including announcement bar and scroll position
  const header = document.querySelector('.header__outer-wrapper') || document.querySelector('[data-section-type="header"]');
  if (header) {
      document.documentElement.style.setProperty('--quick-cart-offset', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
  }

  // Use instance method if available
  const instance = getQuickCartInstance();
  const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
  // Check active class on wrapper (standard theme behavior)
  const isCartOpen = quickCartWrapper && quickCartWrapper.classList.contains('active');
  
  if (!isCartOpen) {
      if (instance) {
          instance.openQuickCart();
      } else {
          const event = new CustomEvent('quick-cart:open', { bubbles: true, cancelable: true, detail: {} });
          document.dispatchEvent(event);
      }
      document.body.classList.add('is-hover-cart-open');
  }
}

function closeQuickCart() {
  const instance = getQuickCartInstance();
  const closeBtn = document.querySelector('.quick-cart__close-icon');
  
  if (instance && typeof instance.close === 'function') {
      instance.close();
  } else if (closeBtn) {
       closeBtn.click();
  } else {
      // Last resort: remove class manually (not ideal but works for visuals)
      const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
      if (quickCartWrapper) quickCartWrapper.classList.remove('active');
      document.body.removeAttribute('data-fluorescent-overlay-open');
  }
  document.body.classList.remove('is-hover-cart-open');
}

function scheduleCloseCart() {
  clearTimeout(closeCartTimeout);
  closeCartTimeout = setTimeout(() => {
    
      const isHoveringIcon = document.querySelector('[data-js-cart-icon]:hover');
      const isHoveringContainer = document.querySelector('.quick-cart__container:hover');
      
      if (isHoveringIcon || isHoveringContainer) {
          return;
      }

      closeQuickCart();
  }, 100);
}

/**
 * Quick Cart Hover Option
 * Opens the quick cart on hover if the setting is enabled in the Quick Cart section.
 */
document.addEventListener('DOMContentLoaded', function() {
    
    function updateHoverState() {
        const quickCartSection = document.querySelector('[data-section-type="quick-cart"]');
        const wrapper = document.querySelector('.quick-cart__wrapper');
        const isDesktop = window.innerWidth > 960; // Mobile breakpoint check (Matched to CSS)
        
        if (quickCartSection) {
            const behavior = quickCartSection.getAttribute('data-cart-behavior');
            
            // Only enable hover behavior if it's set to 'hover' AND we are on desktop
            if (behavior === 'hover' && isDesktop) {
                if (!document.body.classList.contains('quick-cart-hover-enabled')) {
                    document.body.classList.add('quick-cart-hover-enabled');
                }
                if(wrapper && !wrapper.classList.contains('quick-cart-hover-enabled')) {
                    wrapper.classList.add('quick-cart-hover-enabled');
                }
                return 'hover';
            } else {
                // If not hover OR not desktop, standard click behavior
                if (document.body.classList.contains('quick-cart-hover-enabled')) {
                    document.body.classList.remove('quick-cart-hover-enabled');
                }
                 if(wrapper && wrapper.classList.contains('quick-cart-hover-enabled')) {
                    wrapper.classList.remove('quick-cart-hover-enabled');
                }
                return 'click';
            }
        }
        return 'click'; // Default
    }

    // Initial check
    updateHoverState();

    // Listen for resize to toggle behavior dynamically
    window.addEventListener('resize', function() {
        updateHoverState();
    });

    // Unified Event Delegation
    document.body.addEventListener('mouseover', function(e) {
        const target = e.target;
        
        // 1. Hovering Icon
        const cartIcon = target.closest('[data-js-cart-icon]');
        if (cartIcon) {
            // Check global/section behavior
            const behavior = updateHoverState(); // Ensure state is synced
            
            if (behavior === 'hover') {
                openQuickCart();
            }
            return;
        }

        // 2. Hovering Container (any part of it)
        if (target.closest('.quick-cart__container')) {
            clearTimeout(closeCartTimeout);
        }
    });

    document.body.addEventListener('mouseout', function(e) {
        const target = e.target;
        const related = e.relatedTarget;
        
        // Helper to check if related target is "safe" (inside icon or container)
        function isSafelyInside(element) {
            if (!element) return false;
            // Check if element is inside icon
            if (element.closest('[data-js-cart-icon]')) return true;
            // Check if element is inside card drawer
            if (element.closest('.quick-cart__container')) return true;
            return false;
        }

        // 1. Leaving Icon
        const cartIcon = target.closest('[data-js-cart-icon]');
        // Check effective behavior (respects desktop limit)
        const behavior = updateHoverState(); 
        
        // Only trigger auto-close if behavior is 'hover'
        if (cartIcon && behavior === 'hover') {
             // If we didn't move to a safe place, close
             if (!isSafelyInside(related)) {
                 scheduleCloseCart();
             }
             return;
        }

        // 2. Leaving Container
        // We only care if we were *actually* in the container
        const container = target.closest('.quick-cart__container');
        if (container) {
            // Check if we left the container entirely
            if (!container.contains(related)) {
                 if (behavior === 'hover') {
                     // And check we didn't go back to icon
                     if (!isSafelyInside(related)) {
                         scheduleCloseCart();
                     }
                 }
            }
        }
    });
});

// add class in body as per os

const userAgent = navigator.userAgent.toLowerCase();
let browserName = '';

// Detect Brave first (since Brave also reports as Chrome)
if (navigator.brave && navigator.brave.isBrave) {
  navigator.brave.isBrave().then((isBrave) => {
    if (isBrave) {
      document.body.classList.add('browser-brave');
    } else {
      detectBrowser(); // fallback to others if not Brave
    }
  });
} else {
  detectBrowser();
}
function detectBrowser() {
  if (userAgent.includes('edge')) {
    browserName = 'edge';
  } else if (userAgent.includes('chrome')) {
    browserName = 'chrome';
  } else if (userAgent.includes('firefox')) {
    browserName = 'firefox';
  } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    browserName = 'safari';
  } else if (userAgent.includes('opr') || userAgent.includes('opera')) {
    browserName = 'opera';
  } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
    browserName = 'ie';
  }

  if (browserName) {
    document.body.classList.add('browser-' + browserName);
  }
}

// bottom menu

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const primary = document.querySelector('.drawer-menu__primary-links');
    const bottom = document.querySelector('.drawer-menu__list--bottom-menu');
    if (primary && bottom) {
      const depth = primary.getAttribute('data-depth') || '0';
      bottom.setAttribute('data-depth', depth);
      
      // Find the currently active submenu in bottom to ensure it aligns to top
      const activeSub = bottom.querySelector('.drawer-menu__list--sub.visible');
      if (activeSub && depth !== '0') {
          // The distance to offset is the negative of the bottom container's current top relative to the drawer main
          const mainRect = document.querySelector('.drawer-menu__main').getBoundingClientRect();
          const bottomRect = bottom.getBoundingClientRect();
          // Move the bottom menu up so its top aligns with the main container
      }
    }
  });
  const primaryLinks = document.querySelector('.drawer-menu__primary-links');
  if (primaryLinks) {
    observer.observe(primaryLinks, { attributes: true, attributeFilter: ['data-depth'] });
  }
});

/**
 * Preorder por metafields: custom.stock_status + custom.preorder_date.
 * Si stock_status es "In Stock" y preorder_date no está vacío → Add to cart. Si no → Preorder.
 * El mapa por variante viene en data-preorder-display-map (Liquid). Al cambiar variante se aplica sin API.
 */
(function () {
  function getCurrentVariantId(form) {
    var input = form.querySelector('[name="id"]') || form.querySelector('[data-variant-select]');
    var val = input && input.value;
    return val ? String(val).trim() : null;
  }

  function getDisplayMapFromForm(form) {
    var mapAttr = form.getAttribute('data-preorder-display-map');
    if (!mapAttr || mapAttr === '{}') return null;
    try {
      var parsed = JSON.parse(mapAttr);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (e) {}
    return null;
  }

  function applyPreorderOverride(container, variantId, displayMap) {
    if (!container || !variantId || !displayMap) return;
    var variantIdNum = String(variantId).replace(/^.*\//, '');
    var showAddToCart = displayMap[variantIdNum] || displayMap[variantId];

    var addToCartBtns = container.querySelectorAll('[data-add-to-cart]');
    var preorderBlocks = container.querySelectorAll('[data-preorder-delivery-block]');
    var preorderInputs = container.querySelectorAll('[data-preorder-delivery-input]');

    if (showAddToCart) {
      addToCartBtns.forEach(function (btn) {
        var label = btn.dataset && btn.dataset.langAvailable;
        var textEl = btn.querySelector('[data-add-to-cart-text]');
        if (textEl && label) textEl.textContent = label;
      });
      preorderBlocks.forEach(function (block) { block.classList.add('hidden'); });
      preorderInputs.forEach(function (input) {
        input.removeAttribute('name');
        input.value = '';
      });
      return;
    }

    var form = container.querySelector && container.querySelector('[data-product-form]') || (container.matches && container.matches('form[data-product-form]') ? container : null);
    if (!form) return;
    var datesJson = form.dataset && form.dataset.preorderDeliveryDates;
    var dates = {};
    if (datesJson) try { dates = JSON.parse(datesJson); } catch (err) {}
    var dateVal = dates[variantIdNum] || dates[variantId];
    var btn = addToCartBtns[0];
    var preorderIdsJson = btn && btn.dataset && btn.dataset.preorderVariantIds;
    var isPreorderVariant = false;
    if (preorderIdsJson) try {
      var ids = JSON.parse(preorderIdsJson);
      isPreorderVariant = Array.isArray(ids) && ids.some(function (id) { return String(id) === String(variantIdNum) || Number(id) === Number(variantIdNum); });
    } catch (err) {}
    if (!isPreorderVariant || !dateVal) return;
    addToCartBtns.forEach(function (b) {
      var label = b.dataset && b.dataset.langPreorder;
      var textEl = b.querySelector('[data-add-to-cart-text]');
      if (textEl && label) textEl.textContent = label;
    });
    preorderBlocks.forEach(function (block) { block.classList.remove('hidden'); });
    var dateDisplay = container.querySelector('[data-preorder-date-display]');
    if (dateDisplay) dateDisplay.textContent = dateVal;
    preorderInputs.forEach(function (input) {
      var propName = (input.dataset && input.dataset.propertyName) || 'Estimated delivery';
      input.setAttribute('name', 'properties[' + propName + ']');
      input.value = dateVal;
    });
  }

  function runForAllProductForms() {
    var forms = document.querySelectorAll('form[data-product-form][data-product-id][data-has-preorder-variant="true"]');
    forms.forEach(function (form) {
      var section = form.closest('[data-section-id]');
      var container = section || form;
      var variantId = getCurrentVariantId(form);
      if (!variantId) return;
      var map = getDisplayMapFromForm(form);
      if (map) applyPreorderOverride(container, variantId, map);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    runForAllProductForms();
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          var form = node.querySelector && node.querySelector('form[data-product-form][data-product-id][data-has-preorder-variant="true"]') || (node.matches && node.matches('form[data-product-form][data-product-id][data-has-preorder-variant="true"]') ? node : null);
          if (form) runForAllProductForms();
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('product:variant-change', function () {
    runForAllProductForms();
  });

  document.body.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-product-form][data-product-id][data-has-preorder-variant="true"]');
    if (!form && e.target.matches && e.target.matches('form[data-product-form][data-product-id][data-has-preorder-variant="true"]'))
      form = e.target;
    if (form) runForAllProductForms();
  }, true);
})();